import axios from 'axios';

const BASE_URL = '/app/funnelIntegrationAction';

export const duplicateHttpRequestConfig = async (currentHttpRequestConfigId) => {
    const payload = {
        httpRequestConfigId: Number(currentHttpRequestConfigId),
    };

    const { data } = await axios.post(`${BASE_URL}`, payload);

    return data;
};

export const getActionConfigData = async (httpRequestConfigId) => {
    const { data } = await axios.get(`${BASE_URL}/${httpRequestConfigId}`);

    return data;
};

export const updateActionConfigData = async (updateIntegrationActionRequest) => {
    await axios.put(`${BASE_URL}`, updateIntegrationActionRequest);
};
